export default "__VITE_ASSET__CVHL$uLg__"